// extracted by mini-css-extract-plugin
module.exports = {"formWrap":"CommentForm_formWrap__2OtiO","formUserAvatar":"CommentForm_formUserAvatar__37kJf","formCommentText":"CommentForm_formCommentText__1xzqC"};